import { Box } from '@startuptools/ui/Box';
import { Chip } from '@startuptools/ui/Chip';
import { GqlStripeSubscriptionStatus } from '../../graphql/base-types.graphql';
import { Trans } from '@lingui/react';
import { type ReactNode } from 'react';

const stripeStatusHumanMap: Record<GqlStripeSubscriptionStatus, ReactNode> = {
  [GqlStripeSubscriptionStatus.Active]: <Trans id="Active" />,
  [GqlStripeSubscriptionStatus.Unpaid]: <Trans id="Unpaid" />,
  [GqlStripeSubscriptionStatus.Paused]: <Trans id="Paused" />,
  [GqlStripeSubscriptionStatus.PastDue]: <Trans id="Past due" />,
  [GqlStripeSubscriptionStatus.Canceled]: <Trans id="Canceled" />,
  [GqlStripeSubscriptionStatus.Trialing]: <Trans id="Trialing" />,
  [GqlStripeSubscriptionStatus.Incomplete]: <Trans id="Incomplete" />,
  [GqlStripeSubscriptionStatus.IncompleteExpired]: <Trans id="Incomplete Expired" />,
};

export const StripeStatusHuman = ({ children }: { children: GqlStripeSubscriptionStatus }) => {
  return stripeStatusHumanMap[children];
};

export const StripeStatusChip = ({ children }: { children?: GqlStripeSubscriptionStatus | null }) => {
  if (!children) {
    return null;
  }

  switch (children) {
    case GqlStripeSubscriptionStatus.Active: {
      return (
        <Box>
          <Chip variant="solid" color="success" size="sm">
            <StripeStatusHuman>{children}</StripeStatusHuman>
          </Chip>
        </Box>
      );
    }
    case GqlStripeSubscriptionStatus.Unpaid: {
      return (
        <Box>
          <Chip variant="solid" color="danger" size="sm">
            <StripeStatusHuman>{children}</StripeStatusHuman>
          </Chip>
        </Box>
      );
    }
    case GqlStripeSubscriptionStatus.Paused: {
      return (
        <Box>
          <Chip variant="solid" color="warning" size="sm">
            <StripeStatusHuman>{children}</StripeStatusHuman>
          </Chip>
        </Box>
      );
    }
    case GqlStripeSubscriptionStatus.PastDue: {
      return (
        <Box>
          <Chip variant="solid" color="danger" size="sm">
            <StripeStatusHuman>{children}</StripeStatusHuman>
          </Chip>
        </Box>
      );
    }
    case GqlStripeSubscriptionStatus.Canceled: {
      return (
        <Box>
          <Chip variant="solid" color="warning" size="sm">
            <StripeStatusHuman>{children}</StripeStatusHuman>
          </Chip>
        </Box>
      );
    }
    case GqlStripeSubscriptionStatus.Trialing: {
      return (
        <Box>
          <Chip variant="solid" color="primary" size="sm">
            <StripeStatusHuman>{children}</StripeStatusHuman>
          </Chip>
        </Box>
      );
    }
    case GqlStripeSubscriptionStatus.Incomplete: {
      return (
        <Box>
          <Chip variant="solid" color="danger" size="sm">
            <StripeStatusHuman>{children}</StripeStatusHuman>
          </Chip>
        </Box>
      );
    }
    case GqlStripeSubscriptionStatus.IncompleteExpired: {
      return (
        <Box>
          <Chip variant="solid" color="danger" size="sm">
            <StripeStatusHuman>{children}</StripeStatusHuman>
          </Chip>
        </Box>
      );
    }
  }
};
